import Layout from "../../../components/layout/layout.js";
import PullReport from "../../../components/pull-report/PullReport.js";

function PullReportPage({ component, ...rest }) {
  return <Layout Component={PullReport} controlsDisabled={true} {...rest} />;
}

export default PullReportPage;
